document.addEventListener('DOMContentLoaded', () => {
    return;
    let popupBg = document.querySelector('.popup__bg'); 
    let popup = document.querySelector('.popup'); 
    let closePopupButton = document.querySelector('.close-popup'); 
    if (popupBg && popup) {
        setTimeout(() => {
            popupBg.classList.add('active'); 
            popup.classList.add('active');
        }, 1000);
        closePopupButton.addEventListener('click', () => { 
            popupBg.classList.remove('active'); 
            popup.classList.remove('active'); 
        });
        document.addEventListener('click', (e) => { 
            if (e.target === popupBg) { 
                popupBg.classList.remove('active'); 
                popup.classList.remove('active'); 
            }
        });
    }
});